import { render, staticRenderFns } from "./AddRecipeUseStateItems.vue?vue&type=template&id=b626fe52&"
import script from "./AddRecipeUseStateItems.vue?vue&type=script&lang=js&"
export * from "./AddRecipeUseStateItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports